<template>
    <div>
        <!-- Display assets based on the selected month and theme -->
        <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h2>{{ targetType }} Canva Reels</h2> <!-- Optional: Display type as a header -->
              </v-col>
            </v-row>
            <!-- Loop through the newsletters for the current type and render them in columns -->
            <v-row>
              <v-col v-for="(reel, index) in reels" :key="index" cols="12" md="3">
                <v-card class="mx-auto" outlined>
                  <v-responsive :aspect-ratio="16/9">
                    <video :src="reel.preview" controls class="gallery-video"></video>
                  </v-responsive>
                  <v-card-actions>
                    <v-btn @click.stop="openDesign(reel.canva)"  download color="primary">Edit in Canva</v-btn>
                    <v-btn @click.stop="openDesign(reel.audio)"  download color="primary">Audio</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
        </v-container>
    </div>
  </template>
  
  <script>
    import previousReels from '@/assets/dfy-reels-previous.json'  // Import the content data
    import currentReels from '@/assets/dfy-reels-current.json'  // Import the content data
    
    export default {
        name: 'DFYReels',
        data: () => ({
          previousMonth: '',
          currentMonth: '',
          targetType: '',
        }),
        mounted() {
          this.scrollToTargetGroup();
          this.targetType = this.$route.query.targetType || '';
          this.previousMonth = this.$route.query.previousMonth || '';
          this.currentMonth = this.$route.query.currentMonth || '';
        },
        computed: {
          reels() {
            if (this.targetType === this.previousMonth) {
              return previousReels;
            } else {
              return currentReels;
            }
          }
        },
        methods: {
          // Open the design in a new tab when a card is clicked
          openDesign(url) {
            window.open(url, '_blank');
          },
          scrollToTargetGroup() {
            if (this.targetGroupType) {
              const targetElement = this.$refs[this.targetGroupType];
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
              }
            }
          },
        },
    }
  </script>
  
  <style scoped>
    .gallery-video {
      width: 100%;
      cursor: pointer;
    }

    .title-truncate {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ellipsis {
      display: block;
      width: 100%;         /* Make sure the width is limited by its container */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
   
    .v-card-title {
      padding: 16px 16px 8px;  /* Padding around the title */
    }
  
    .v-card-subtitle {
      padding: 4px 16px 4px;  /* Padding around the subtitle */
    }
  </style>